import React, { useRef } from 'react';
import { Icon } from 'semantic-ui-react';
import analytics from '../../shared/services/analytics/analytics';
import { getThumbnailUrl } from '../../components/Box/Box';
import { PUBLIC_URL } from '../../config';
import { useLearn2QuantVideoCourses } from '../../shared/api/apiHooks';
import { LEARN_VIDEO_COURSES_PAGE_PATH } from '../../shared/constants';
import './TutorialL2Q.scss';

export function TutorialLearn2Quant() {
  const containerRef = useRef<HTMLDivElement>(null);

  const { data: videoCourses, isLoading, isError } = useLearn2QuantVideoCourses();

  if (isLoading || isError || videoCourses?.length === 0) {
    return null;
  }

  const handleScroll = (direction: 'prev' | 'next') => {
    if (containerRef.current) {
      const card = containerRef.current.querySelector('.l2q-videos__card');
      if (card) {
        const cardWidth = card.clientWidth;
        const gap = parseInt(window.getComputedStyle(containerRef.current).gap);
        const scrollAmount = direction === 'prev' ? -(cardWidth + gap) : cardWidth + gap;
        containerRef.current.scrollBy({ behavior: 'smooth', left: scrollAmount });
      }
    }
  };

  const handlePrevClick = () => handleScroll('prev');
  const handleNextClick = () => handleScroll('next');

  return (
    <div className="l2q-videos">
      <div className="l2q-videos__header">
        <h2 className="l2q-videos__title">Kickstart Your Quant Journey with These Essential Courses</h2>
        <div className="l2q-videos__navigation">
          <button className="l2q-videos__nav-btn l2q-videos__nav-btn--prev" onClick={handlePrevClick}>
            <Icon name="chevron left" fitted size="tiny" />
          </button>
          <button className="l2q-videos__nav-btn l2q-videos__nav-btn--next" onClick={handleNextClick}>
            <Icon name="chevron right" fitted size="tiny" />
          </button>
        </div>
      </div>

      <div className="l2q-videos__container" ref={containerRef}>
        {videoCourses?.map((course, index) => (
          <a
            key={course.id}
            href={`${PUBLIC_URL}${LEARN_VIDEO_COURSES_PAGE_PATH}/${course.id}`}
            target="_blank"
            rel="noreferrer"
            className="l2q-videos__link"
            onClick={() => analytics.trackCustomEvent('sim_click_video_course', { event_label: course.title })}
          >
            <div className="l2q-videos__card">
              <img
                className="l2q-videos__card-thumbnail"
                alt={course.title}
                src={getThumbnailUrl({
                  videoId: course.videos[0].uid,
                  source: course.videos[0].source,
                })}
              />
              <div className="l2q-videos__card-content">
                <h3 className="l2q-videos__card-title">{course.title}</h3>
                <p className="l2q-videos__card-description">{course.description}</p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default TutorialLearn2Quant;
